import { Card, CardContent, CardHeader, Divider, IconButton } from '@mui/material';
import { useTheme } from '@mui/system';
import React, { forwardRef } from 'react';

type Props = {
    title: string;
    styles?: React.CSSProperties;
    children: React.ReactNode;
    onClose?: () => void;
    isModal?: boolean;
};

export const CardContainer = forwardRef<HTMLDivElement, Props>((props, ref) => {
    const theme = useTheme();
    return (
        <Card
            ref={ref}
            sx={{
                ...props.styles,
                overflow: 'unset',
                padding: 0,
                width: 'calc(100vw - 32px)',
                maxWidth: '625px',
                border: props.isModal ? '2px solid' : 'none',
                borderColor: props.isModal ? theme.palette.primary.main : undefined
            }}
            elevation={9}
            tabIndex={-1}>
            {props.onClose && (
                <IconButton
                    sx={{
                        position: 'absolute',
                        right: '6px',
                        top: '6px',
                        width: '34px'
                    }}
                    onClick={() => props.onClose()}
                    aria-label='close'
                    size='small'>
                    &#10006;
                </IconButton>
            )}
            <CardHeader sx={{ paddingTop: 3 }} title={props.title} />
            <Divider />
            <CardContent sx={{ paddingBottom: '24px !important', paddingTop: '24px !important' }}>{props.children}</CardContent>
        </Card>
    );
});
